// extracted by css-extract-rspack-plugin
export default {"collectionSyncList":"YgiMf"};